import {LOCALE_ID, NgModule} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { appRoutes } from './app.routes';
import { NxWelcomeComponent } from './nx-welcome.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  HTTP_INTERCEPTORS,
  HttpClientModule,
  provideHttpClient,
  withInterceptorsFromDi
} from '@angular/common/http';
import {
  ErrorInterceptor,
  TokenService,
  AuthInterceptor
} from '@bidvest/shared';
import { NgxUiLoaderModule, NgxUiLoaderRouterModule } from 'ngx-ui-loader';
import { JwtModule } from '@auth0/angular-jwt';
import { provideToastr } from 'ngx-toastr';
import { FileSaverModule } from 'ngx-filesaver';
import {registerLocaleData} from "@angular/common";
import localeZA from '@angular/common/locales/en-ZA';

export function tokenGetter() {
  return TokenService.TOKEN;
}
registerLocaleData(localeZA);

@NgModule({
  declarations: [AppComponent, NxWelcomeComponent],
  imports: [
    BrowserModule,
    RouterModule.forRoot(appRoutes, { bindToComponentInputs: true }),
    NgxUiLoaderModule,
    NgxUiLoaderRouterModule,
    HttpClientModule,
    JwtModule.forRoot({
      config: { tokenGetter: tokenGetter, skipWhenExpired: true }
    }),
    FileSaverModule
  ],
  providers: [
    {provide: LOCALE_ID, useValue: 'en-ZA'},
    provideAnimationsAsync(),
    provideToastr(),
    provideHttpClient(withInterceptorsFromDi()),
    ErrorInterceptor,
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
